import {Contact} from '../models/contact.model';

export class ContactsState {
  items: Contact[];
}
